import { useState } from "react";
import AbstractController from "../../../../../vendors/services/abstractController";
import EventoService from "../../../../services/evento.service";
import ConsultarEventosFilter from "../filters/ConsultarEventosFilter";
import ToastService from "../../../../../vendors/services/toastService";
import EventoModel from "../../../../shared/model/evento.model";
import { ConsultarEventosConstants } from "../utils/ConsultarEventosConstants";
import {
  ConsultarEventosFiltrosStorage,
  lerFiltrosDoStorage,
  removerFiltrosDoStorage,
} from "../utils/filterStorage";
import {
  ativarLayoutEventoInterno,
  idDoEvento,
  isEventoInterno,
} from "../../../../shared/utils/EventoInternoUtil";

const SITUACOES_OCULTAS = ["cadastrado", "inativo"];

function situacaoOcultaNoFiltro(descricao: string): boolean {
  const texto = (descricao || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  return SITUACOES_OCULTAS.includes(texto);
}

export default class ConsultarEventosController extends AbstractController {
  private service: EventoService;
  public filter: ConsultarEventosFilter;

  public lista: any;
  public setLista: any;
  public anoList: any;
  public setAnoList: any;
  public tipoEventoList: any;
  public setTipoEventoList: any;
  public situacaoList: any;
  public setSituacaoList: any;
  public total: any;
  public setTotal: any;
  public evento: EventoModel;
  public setEvento: any;

  public lazyParams: any;
  public setLazyParams: any;
  public visibleLogin: any;
  public setVisibleLogin: any;

  constructor() {
    super();
    [this.lista, this.setLista] = useState([]);
    [this.total, this.setTotal] = useState(0);
    [this.lazyParams, this.setLazyParams] = useState({
      first: 0,
      rows: 10,
      page: 1,
    });
    [this.anoList, this.setAnoList] = useState([]);
    [this.tipoEventoList, this.setTipoEventoList] = useState([]);
    [this.situacaoList, this.setSituacaoList] = useState([]);
    [this.visibleLogin, this.setVisibleLogin] = useState(false);
    [this.evento, this.setEvento] = useState(Object);

    this.service = new EventoService();
    this.filter = new ConsultarEventosFilter();
  }

  init() {
    super.init();
    const salvos = lerFiltrosDoStorage();
    if (salvos) {
      this.filter.setFromObject(salvos);
      this.consultarComFiltro(salvos);
    } else {
      this.consultar();
    }
    this.getAnoList();
    this.getSituacaoList();
    this.getTipoEventoList();
  }

  getAnoList() {
    this.service.getAno().then((res: any) => {
      this.setAnoList(res.result || []);
    });
  }

  getSituacaoList() {
    this.service.getSituacaoADM().then((res: any) => {
      const lista = (res.result || []).filter(
        (item: any) => !situacaoOcultaNoFiltro(item?.descricao)
      );
      this.setSituacaoList(lista);
    });
  }

  getTipoEventoList() {
    this.service.getTipoEvento(true).then((res: any) => {
      this.setTipoEventoList(res.result || []);
    });
  }

  onPage(e: any) {
    this.consultar(e.page, e.rows, e);
  }

  consultarComFiltro(json: ConsultarEventosFiltrosStorage) {
    this.executarConsulta({
      ...json,
      page: 0,
      pageSize: 10,
    });
  }

  consultar(
    page: number = 0,
    pageSize: number = 10,
    e?: any,
    ordering: any = null
  ) {
    const obj: any = { ...this.filter };
    obj.page = page;
    obj.pageSize = pageSize;
    if (ordering != null) {
      obj.ordering = ordering;
    }
    this.executarConsulta(obj, e);
  }

  private executarConsulta(params: any, e?: any) {
    const obj: any = { ...params };
    if (
      !obj.stAgendaRegulatoria ||
      obj.stAgendaRegulatoria === ConsultarEventosConstants.AGENDA_AMBOS
    ) {
      delete obj.stAgendaRegulatoria;
    }
    this.start();
    this.service
      .findAll(obj)
      .then((res) => {
        this.stop();
        if (e) {
          this.setLazyParams(e);
        }
        if (res.result && res.result.items) {
          this.setLista(res.result.items);
          this.setTotal(res.result.totalItems);
        } else {
          this.setLista([]);
          this.setTotal(0);
        }
      })
      .catch(() => this.stop());
  }

  async shareEvent(params: {
    dsLink: string;
    dsEmail: string;
    dsNota: string;
  }): Promise<any> {
    try {
      this.start();
      await this.service.compartilharEvento(params);
      this.stop();
      ToastService.showSuccess("Compartilhamento realizado com sucesso!");
    } catch (err) {
      this.stop();
      ToastService.showError("Erro ao compartilhar evento!");
    }
  }

  async getEvento(id: number) {
    try {
      const res: any = await this.service.getEvento(
        id,
        this.getCodContribuinte() + 0
      );
      return res.result.dsLinkDivulgacaoEvento;
    } catch (error) {
      console.error("Erro ao buscar evento:", error);
      throw error;
    }
  }

  abrirEvento(row: any) {
    const id = idDoEvento(row);
    if (!id) {
      return;
    }
    if (isEventoInterno(row)) {
      sessionStorage.setItem("idEventoInterno", String(id));
      ativarLayoutEventoInterno();
      this.history.push("/evento-interno", { id });
      return;
    }
    sessionStorage.setItem("codAudienciaPublica", String(id));
    this.history.push("/evento/visualizar", { id });
  }

  public limpar() {
    this.setLazyParams({ first: 0, rows: 10, page: 1 });
    this.filter.limpar();
    removerFiltrosDoStorage();
  }
}
